import EnumService from '../EnumService'

export default class TipoPessoaEnumService extends EnumService{

    constructor(){
        super('enumTipoPessoa');
    }
  
  }